// extracted by mini-css-extract-plugin
export default {"icon-container":"EmailPage_icon-container__1hjhg","icon-subcontainer":"EmailPage_icon-subcontainer__AZLR2","email-container":"EmailPage_email-container__sYzdc"};